import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import Upload from "../../components/Upload";
// import DataTable from "react-data-table-component";

export default function Edit_SubTopico({ history }) {
  const [titulo, setTitulo] = useState("");
  const [loading, setLoading] = useState("");
  const [ordem, setOrdem] = useState("");
  const [linkVideo, setLinkVideo] = useState("");
  const [minutosVideo, setMinutosVideo] = useState("");

  const url_string = window.location.href;
  const param = url_string.split("/");
  const isMaster = localStorage.getItem("sgimaster");
  const empresaid = localStorage.getItem("sgiempresaid");
  const reqHeaders = { headers: { "x-tenantid": empresaid, isMaster } };

  async function loadProd() {
    let data;
    try {
      const response = await api.get(
        "/treinamentos/subtopico/" + param[4],
        reqHeaders
      );
      data = await response.data;
    } catch (e) {
      setLoading(false);
      if (e.response && e.response.status === 403) {
        alert(
          "Sem permissão para acessar este conteúdo (somente treinamentos da sua empresa)."
        );
        history.push("/produtos");
      }
      return;
    }

    setTitulo(data[0].titulo);
    setOrdem(data[0].ordem);
    setLinkVideo(data[0].linkVideo);
    setMinutosVideo(data[0].minutosVideo);
    setLoading(false);
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const dataobj = {
      titulo,
      ordem,
      linkVideo,
      minutosVideo
    };

    await api.put("/treinamentos/subtopico/" + param[4], dataobj, reqHeaders);
    setLoading(false);
    history.go(-1);
  }

  
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (document.getElementById("menu_produto")) {
        document.getElementById("menu_produto").className = "active";
      }
    }, 50);
    loadProd();
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>{titulo}</h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box-footer">
                <button
                  className="btn btn-default"
                  style={{ marginRight: 8 }}
                  onClick={() => history.goBack()}
                >
                  Voltar
                </button>

                <button
                  type="submit"
                  form="formCheck"
                  className="btn btn-success"
                  style={{ marginRight: 8 }}
                >
                  Salvar
                </button>
              </div>
              <div className="box box-primary">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80"></img>
                  </div>
                )}
                <form
                  id="formCheck"
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                >
                  <div className="box-body">
                  <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="ordemvideo">
                        Ordem*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="ordemvideo"
                          placeholder="Ordem na lista"
                          className="form-control"
                          value={ordem}
                          required
                          maxLength={40}
                          onChange={(event) => setOrdem(event.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="titulovideo">
                        Titulo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="titulovideo"
                          placeholder="Nome do Produto"
                          className="form-control"
                          value={titulo}
                          required
                          onChange={(event) => setTitulo(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="linkvideo">
                        Link Video*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="linkVideo"
                          placeholder="Link do Youtube"
                          className="form-control"
                          value={linkVideo}
                          required
                          onChange={(event) => setLinkVideo(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="minutos">
                        Minutos do Video*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="minutosVideo"
                          placeholder="Minutagem do Video"
                          className="form-control"
                          value={minutosVideo}
                          required
                          onChange={(event) => setMinutosVideo(event.target.value)}
                        />
                      </div>
                    </div>
                    
                    
                      </div>


                  {/* <div className="box-footer">
                  <button
                      className="btn btn-default"
                      style={{marginRight:8}}
                      onClick={() => history.push("/produtos")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>



      <Footer />
    </>
  );
}
